import { z } from 'zod';
import { Email, IsoDateTime, PageQuery, Uuid } from './common.js';
export const SiteScope = z.enum(['all', 'assigned']);
export const UserStatus = z.enum(['invited', 'active', 'disabled']);
export const User = z.object({
    id: Uuid,
    accountId: Uuid,
    email: z.string(),
    fullName: z.string(),
    roleId: Uuid,
    roleName: z.string(),
    status: UserStatus,
    /** Site ids the user is limited to; only used when the role's siteScope is 'assigned'. */
    siteIds: z.array(Uuid),
    twoFactorEnabled: z.boolean(),
    lastLoginAt: IsoDateTime.nullable(),
    createdAt: IsoDateTime,
    updatedAt: IsoDateTime,
});
export const UserListQuery = PageQuery.extend({
    status: UserStatus.optional(),
    roleId: Uuid.optional(),
    sort: z.enum(['fullName', 'email', 'lastLoginAt', 'createdAt']).optional(),
});
/** Creates the tenant membership and emails an invite. If the email already has an account it is reused. */
export const UserCreate = z.object({
    email: Email,
    fullName: z.string().trim().min(1).max(120),
    roleId: Uuid,
    siteIds: z.array(Uuid).max(500).default([]),
});
export const UserUpdate = z
    .object({
    fullName: z.string().trim().min(1).max(120),
    roleId: Uuid,
    siteIds: z.array(Uuid).max(500),
    status: z.enum(['active', 'disabled']),
})
    .partial();
export const Role = z.object({
    id: Uuid,
    /** 'administrator' | 'standard' for built-in roles, null for custom ones. */
    key: z.string().nullable(),
    name: z.string(),
    description: z.string(),
    builtin: z.boolean(),
    editable: z.boolean(),
    siteScope: SiteScope,
    permissions: z.array(z.string()),
    userCount: z.number().int().min(0),
    createdAt: IsoDateTime,
    updatedAt: IsoDateTime,
});
export const RoleCreate = z.object({
    name: z.string().trim().min(1).max(80),
    description: z.string().trim().max(500).default(''),
    siteScope: SiteScope.default('all'),
    /** Tenant-scope permission keys only; unknown keys are rejected. */
    permissions: z.array(z.string()).max(500),
});
/** PATCH body. Not RoleCreate.partial(): the create defaults would overwrite fields the caller didn't send. */
export const RoleUpdate = z.object({
    name: z.string().trim().min(1).max(80).optional(),
    description: z.string().trim().max(500).optional(),
    siteScope: SiteScope.optional(),
    permissions: z.array(z.string()).max(500).optional(),
});
/** One row of GET /api/v1/permissions (the catalogue for the role editor). */
export const PermissionInfo = z.object({
    key: z.string(),
    group: z.string(),
    module: z.string(),
    sensitive: z.boolean(),
    /** False when the owning module is switched off for this tenant (still assignable, has no effect). */
    moduleEnabled: z.boolean(),
});
//# sourceMappingURL=users.js.map